const colorList = ['#0438a1', '#0797fa', '#9feffd', '#4ab99c', '#f5c85f', '#fffca8'];
export default function get2Dpie(data, title = '问题处理', showLegend = false) {
  console.log("data", data)
  let option = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      icon: "circle",
      show: showLegend,
      orient: 'vertical',
      right: '0',
      top: 'center',
      textStyle: {
        color: "#fff",
        fontSize: 20,
        lineHeight: 35
      }
    },
    series: [{
      name: title,
      type: 'pie',
      radius: ['40%', '70%'],
      itemStyle: {
        normal: {
          color: function(params) {
            console.log('params', params)
            return params.data.color
          }
        }
      },
      data,
      center: showLegend ? ['35%', '50%'] : ['50%', '50%'],
      label: {
        formatter(obj) {
          return obj.data.value
        },
        color: "#fff",
        fontSize: 30,
      },
      labelLine: {
        showAbove: true,
        length2: 60,
        lineStyle: {
          color: '#fff',
          width: 2
        },
      },
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }]
  };

  return option
}
